$(document).ready(function(){
  jQuery('.sort-per-page select.num').on('change', function(){
  window.location.replace(jQuery(this).val());
  });
});

//equalheight

$(function ($) {
$(window).on('load',function() {
equalheight('h3.card__heading.h5');
equalheight('h3.card__heading.h5');
});


$(window).on('resize',function() {
equalheight('h3.card__heading.h5');
equalheight('h3.card__heading.h5');
});
});

$(function ($) {

    if ($('#parentHorizontalTab').length) {
      $('#parentHorizontalTab').easyResponsiveTabs({
        type: 'default', //Types: default, vertical, accordion
        width: 'auto', //auto or any width like 600px
        fit: true, // 100% fit in a container
        tabidentify: 'hor_1', // The tab groups identifier
        activate: function(event) { // Callback function if tab is switched
          var $tab = $(this);
          var $info = $('#nested-tabInfo');
          var $name = $('span', $info);
          $name.text($tab.text());
          $info.show();
        }
      });
    }
 
  });

$('.cat_list').slick({
  infinite: true,
  arrows:true,
  slidesToShow: 4,
  slidesToScroll: 1,
   responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.slide_show').slick({
  infinite: true,
  dots:true,
  arrows:false,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true,
});
$('.announcement-bar-section').slick({
  infinite: true,
  dots:false,
  arrows:false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay:true,
});
jQuery(".faq_box h5").first().addClass("show");
jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
else
{jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});

document.addEventListener('DOMContentLoaded', function() {
  const chatButton = document.querySelector('.chat-button');

  chatButton && chatButton.addEventListener('click', function() {
    const shadowRootHost = document.querySelector('inbox-online-store-chat');

    if (shadowRootHost) {
      const shadowRoot = shadowRootHost.shadowRoot;

      if (shadowRoot) {
        const chatToggleButton = shadowRoot.querySelector('.chat-toggle');

        if (chatToggleButton) {
          chatToggleButton.click();
        }
      }
    } else {
      console.error('inbox-online-store-chat element not found');
    }
  });
});
